import { PlantLayoutEditorThemeSizeConfig } from './types';

const small: PlantLayoutEditorThemeSizeConfig = {
  plantLayoutEditor: {},
};

export default small;
